// extracted by mini-css-extract-plugin
module.exports = {"openIdContainer":"styles_openIdContainer__4sxD8","noUserInfoText":"styles_noUserInfoText__dPZ9z utils_commonFlexCenter__fFzcB"};